import classNames from "classnames"
import dayjs from "dayjs"
import { useMemo } from "react"

import { DayMetricComponent } from "./DayMetricComponent"
import { useFeedContext } from "./FeedContext"
import styles from "./FeedDayHeader.module.scss"
import {
  UserEventsLoadedComponent,
  UserEntriesLoadedComponent,
} from "src/components"
import { useDisplayDate } from "src/hooks"

interface Props {
  day: string;
  text?: string; // if provided, the header will render this text instead of the date
  index: number;
}

/*
 * this component renders a header for a specific day of activities
 */
export function FeedDayHeader(props: Props) {
  const {
    day,
    text,
    index,
  } = props

  const { getIndexItem } = useFeedContext()

  const displayDate = useDisplayDate()
  const previousItem = getIndexItem(index - 1)

  const dayStart = useMemo(
    () => dayjs(day)
      .startOf("day")
      .toISOString(),
    [day],
  )

  const className = useMemo(
    () => classNames(
      styles.container,
      // this reduces the space between the "today" header and this header if there are no items between them
      typeof previousItem === "string" && styles.removeTopPadding,
    ),
    [previousItem],
  )

  return (
    <div
      className={className}
      id="feed-day-header"
    >
      {text ?? displayDate(dayStart)}
      <UserEventsLoadedComponent>
        <UserEntriesLoadedComponent>
          <DayMetricComponent dayStart={dayStart} />
        </UserEntriesLoadedComponent>
      </UserEventsLoadedComponent>
    </div>
  )
}
